import { AOI, WAYLEAVE } from "@/utilities/global-variables"

export function getPageNameFromPathname(pathname: string) {
  const parts = pathname.split("/")
  const currentPageKey = parts[parts.length - 1] || "home"

  let portal = WAYLEAVE
  switch (currentPageKey) {
    case "home":
      portal = WAYLEAVE
      break
    case "aoi":
      portal = AOI
      break
    default:
      portal = WAYLEAVE
  }

  return { currentPageKey, portal }
}
